var Skillsets = require("lib/academic/Skillsets");

require("writing/questions/skillset_banner.scss");

var SkillsetBanner = function(props) {
	var className = "skillsetBanner";
	if (props.className) {
		className += " " + props.className;
	}
	if (props.small) {
		className += " smallBanner";
	} else {
		className += " largeBanner";
	}

	if (props.text) {
		var textBox = (
			<p className="text">{ props.text }</p>
		);
	}

	if (props.classShelf && props.skillset == "review" ) {
		var title = "Reviews";
		
	} else if (props.textVariety) {
		var title = (
			<span className="inner">
				{ Skillsets.getShortName(props.skillset, props.textVariety) }
			</span>
		);

	} else {
		var title = (
			<span className="inner">
				{ Skillsets.getShortName(props.skillset) }
			</span>
		)
	}

	var skillsetData = Skillsets.getData(props.skillset);
	if (skillsetData) {
		var skillsetEnv = skillsetData["env"];
		var src = dynamicRequire("skillset-banners/banner-" + skillsetEnv + ".png")
		var skillsetImg = (
			<img src={ src } className="banner" />
		);
	}

	return (
		<div className={ className } onClick={ props.onClick }>
			<p className="title">{ title }</p>
			{ skillsetImg }
			{ textBox }
		</div>
	);
};

SkillsetBanner.propTypes = StrictPropTypes({
	skillset: PropTypes.string.isRequired,
	textVariety: PropTypes.string,

	// Optional text to disply underneath the banner
	text: PropTypes.string,

	// Meant to show at slightly less than 50% width
	small: PropTypes.bool,

	// Function called when outer div is selected
	onClick: PropTypes.func,

	//Boolean detects if banner is being used on Shelves Page
	classShelf: PropTypes.bool,

	// Optional className
	className: PropTypes.string,
});

module.exports = SkillsetBanner;



// WEBPACK FOOTER //
// ./modules/components/writing/questions/SkillsetBanner.js